<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useUISettings } from 'dashboard/composables/useUISettings';
import FormSelect from 'v3/components/Form/Select.vue';

defineProps({
  label: { type: String, default: '' },
  description: { type: String, default: '' },
});

const { updateUISettings, uiSettings } = useUISettings();
const { t } = useI18n();

const currentEmojiStyle = computed(
  () => uiSettings.value?.ai_emoji_style ?? 'static'
);

const emojiStyleOptions = computed(() => [
  {
    name: t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.AI_EMOJI_STYLE.STATIC'),
    value: 'static',
  },
  {
    name: t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.AI_EMOJI_STYLE.ANIMATED'),
    value: 'animated',
  },
]);

const updateEmojiStyle = async styleValue => {
  try {
    await updateUISettings({ ai_emoji_style: styleValue });
    useAlert(t('PROFILE_SETTINGS.ALERTS.EMOJI_STYLE_UPDATED'));
  } catch (error) {
    useAlert(t('PROFILE_SETTINGS.ALERTS.EMOJI_STYLE_UPDATE_ERROR'));
    throw error;
  }
};

const selectedValue = computed({
  get: () => currentEmojiStyle.value,
  set: value => {
    updateEmojiStyle(value);
  },
});
</script>

<template>
  <div class="flex gap-2 justify-between w-full items-start">
    <div>
      <label class="text-n-gray-12 font-medium leading-6 text-sm">
        {{ label }}
      </label>
      <p class="text-n-gray-11">
        {{ description }}
      </p>
    </div>
    <FormSelect
      v-model="selectedValue"
      name="ai_emoji_style"
      spacing="compact"
      class="min-w-28 mt-px"
      :options="emojiStyleOptions"
      label=""
    >
      <option
        v-for="option in emojiStyleOptions"
        :key="option.value"
        :value="option.value"
        :selected="option.value === selectedValue"
      >
        {{ option.name }}
      </option>
    </FormSelect>
  </div>
</template>
